module.exports = __webpack_public_path__ + "static/media/Diana.899b1581.png";